import React from 'react';
import waves from '../../../images/waves.png';
import play from '../../../images/play.svg';

function SlideTopTen({link, screenshot, posicion, id}) {
    return (
        <span href="" className="SlideTopTen" key={id}>
            <div className="SlideTopTen-caption-play">
                <a href={link}><img src={play} /></a>
            </div>
            <div className="SlideTopTen-caption">
                <h4 className="position">{posicion}</h4>
                <img src={waves} className="waves" />
            </div>
            <img src={screenshot}  />
        </span>
    )
}

export default SlideTopTen